import React from 'react';
import { NumberField, SimpleShowLayout } from 'react-admin';
import Heading from 'components/Heading';
import { Divider, Typography } from '@mui/material';
import MoneyField from 'components/MoneyField';

type W2BurdensSectionProps = {
  settingsField: string;
};

export const W2BurdensSection = ({ settingsField }: W2BurdensSectionProps) => {
  return (
    <SimpleShowLayout spacing={0} sx={{ padding: 0, marginBottom: 3 }}>
      <Typography variant="h6" data-testid="heading">
        W2 Burdens
      </Typography>
      <Divider />

      <SimpleShowLayout>
        <Heading>W2 Global Burdens</Heading>

        <NumberField
          label="Social Security Burden Multiplier"
          source={`${settingsField}.w2.social_security_burden_multiplier`}
        />
        <NumberField
          label="Medicare Burden Multiplier"
          source={`${settingsField}.w2.medicare_burden_multiplier`}
        />
        <MoneyField
          label="Federal Unemployment Max Burden"
          source={`${settingsField}.w2.federal_unemployment_max_burden_cents`}
        />
        <NumberField
          label="Federal Unemployment Percent Burden Multiplier"
          source={`${settingsField}.w2.federal_unemployment_percent_burden_multiplier`}
        />
        <MoneyField
          label="State Unemployment Max Burden"
          source={`${settingsField}.w2.state_unemployment_max_burden_cents`}
        />
        <NumberField
          label="State Unemployment Percent Burden Multiplier"
          source={`${settingsField}.w2.state_unemployment_percent_burden_multiplier`}
        />
        <Heading>W2 Assignment Burdens</Heading>
        <NumberField
          label="Billable Orientation Burden Hours"
          source={`${settingsField}.w2.billable_orientation_hours`}
        />
        <NumberField
          label="Non Billable Orientation Burden Hours"
          source={`${settingsField}.w2.non_billable_orientation_burden_hours`}
        />
        <MoneyField
          label="Compliance Burden"
          source={`${settingsField}.w2.compliance_burden_cents`}
        />
        <MoneyField label="ADP fee" source={`${settingsField}.w2.adp_fee_burden_cents`} />
        <MoneyField
          label="Medical (Per Week)"
          source={`${settingsField}.w2.medical_burden_cents`}
        />
      </SimpleShowLayout>
    </SimpleShowLayout>
  );
};
